import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { HelpMePopupComponent } from '../help-me-popup/help-me-popup.component';
import { HelpMeHost } from '../HelpMeHost';
import { StorageService } from '../../../core/storage/storageService';
import { Router } from '@angular/router';
import { MerchantService } from '../../../models/merchant/merchantService';

@Component({
  selector: 'app-help-me-host-button',
  templateUrl: './help-me-host-button.component.html',
  standalone: false,
})
export class HelpMeHostButtonComponent implements OnInit {
  public isVisible: boolean = false;

  private hostUserId: string = '1';
  private session: HelpMeHost = new HelpMeHost({});
  private pollSessionId: number | undefined = undefined;
  private INTERVAL_POLL_FOR_JOIN = 3000;

  constructor(
    private dialog: MatDialog,
    private storageService: StorageService,
    private router: Router,
    private merchantService: MerchantService,
  ) {
    try {
      //const currentRoles = storageService.getCurrentRoles();
      this.isVisible = false; //currentRoles["portal.helpme.host-r"];

      if (this.isVisible)
        console.log('HelpMe! Host is ready to initiate a session');
    } catch (e) {
      debugger;
      this.router.navigate(['signin']);
    }
  }

  async ngOnInit(): Promise<void> {}

  public openSessionDetails() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '400px';
    dialogConfig.height = '400px';
    dialogConfig.data = {
      sessionId: this.session?.sessionId,
      isSupport: true,
    };
    dialogConfig.hasBackdrop = false; // this makes it non-modal
    dialogConfig.panelClass = 'custom-dialog-container';

    const dialogRef = this.dialog.open(HelpMePopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (result.event == 'RequestSession') {
        this.requestNewSession();
      } else if (result.event == 'EndSession') {
        this.endSession();
      }
    });
  }

  public async requestNewSession() {
    this.session = await HelpMeHost.createSession(this.hostUserId, '2') as HelpMeHost;
    this.session?.startSession(this.router);

    console.log(
      'Host is waiting for client to accept session #' +
        this.session?.sessionId +
        ' ...',
    );

    const that = this;
    this.pollSessionId = window.setInterval(function () {
      that.checkSessionAccepted();
    }, this.INTERVAL_POLL_FOR_JOIN);
  }

  public endSession() {
    this.session?.endSession();
  }

  private async checkSessionAccepted() {
    if ((await this.session?.isJoined()) == true) {
      window.clearInterval(this.pollSessionId);
    }
  }
}
